import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { EventsClassifications } from '../Models/events';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  private http = inject(HttpClient); 
  private reqHeader = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('token') || ''
  });
  constructor() { }

  getEventClassifications(fleetId: string): Observable<EventsClassifications[]> {
    return this.http.get<any>(`${environment.API_URL}Device/GetEventFilters/${fleetId}/null`, {
      headers: this.reqHeader
    }).pipe(
      map(response => response?.clasificationList ?? [])
    );
  }

  getVehicles(fleetId: string, callback: (vehicles: any[]) => void): void {
    const userName = localStorage.getItem('UserName');
    this.http.get<any[]>(`${environment.API_URL}Devices/${fleetId}/${userName}/`, {
      headers: this.reqHeader
    }).subscribe({
      next: (res) => {       
        callback(res);
      },
      error: (err) => {
        console.error('Error loading vehicles', err);
        callback([]); 
      }
    });
  }
  getFleetList(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${environment.API_URL}Fleets/userFleet/${id}`, {
      headers: this.reqHeader
    });
  }

}

